<template>
  <v-container>
    <h1 id="user-header">Admin</h1>

    <v-data-table :headers="userHeaders" :items="users" :search="searchUsers">
      <template v-slot:top>
        <v-toolbar flat color="grey lighten-4">
          <v-toolbar-title>Users</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-text-field
            v-model="searchUsers"
            label="Search Users"
            single-line
            hide-details
            prepend-inner-icon="mdi-magnify"
          >
          </v-text-field>
          <v-spacer></v-spacer>
          <template>
            <v-dialog v-model="userDialog" max-width="500px" persistent>
              <template v-slot:activator="{ on }">
                <v-btn color="primary" depressed v-on="on">New User</v-btn>
              </template>
              <v-card>
                <v-card-title>User</v-card-title>
                <v-card-text>
                  <v-layout column>
                    <v-text-field
                      label="First Name"
                      v-model="selectedUser.firstName"
                    >
                    </v-text-field>
                    <v-text-field
                      label="Last Name"
                      v-model="selectedUser.lastName"
                    >
                    </v-text-field>
                    <v-text-field label="NetID" v-model="selectedUser.netId">
                    </v-text-field>
                    <v-select
                      label="Role"
                      v-model="selectedUser.roleId"
                      :items="roles"
                      item-text="roleName"
                      item-value="id"
                    ></v-select>
                  </v-layout>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    text
                    v-if="!isEdit"
                    @click="saveNewUser"
                    color="primary"
                    >Save</v-btn
                  >
                  <v-btn
                    text
                    v-if="isEdit"
                    @click="saveEditUser"
                    color="primary"
                    >Save Changes</v-btn
                  >
                  <v-btn color="error" text @click="resetUserDialog"
                    >Cancel</v-btn
                  >
                </v-card-actions>
              </v-card>
            </v-dialog>
          </template>
        </v-toolbar>
      </template>
      <template v-slot:item.action="{ item }">
        <v-btn small text icon>
          <v-icon @click="setEditUser(item)">edit</v-icon>
        </v-btn>
        <v-btn small text icon>
          <v-icon color="error" @click="showUserMessage(item)">clear</v-icon>
        </v-btn>
      </template>
    </v-data-table>
    <v-dialog v-model="userMessage" max-width="500px" persistent>
      <v-card>
        <v-card-title>Are you sure you want to delete this user?</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="deleteUser">Yes</v-btn>
          <v-btn color="error" text @click="hideUserMessage()">No</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="messageDialog" max-width="500px">
      <v-card>
        <v-card-title>{{ dialogText }}</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="hideMessageDialog">Okay</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-data-table
      class="mt-12"
      :headers="internshipHeaders"
      :items="internships"
      :search="searchInternships"
    >
      <template v-slot:top>
        <v-toolbar flat color="grey lighten-4">
          <v-toolbar-title>Internships</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-text-field
            v-model="searchInternships"
            label="Search Internships"
            single-line
            hide-details
            prepend-inner-icon="mdi-magnify"
          >
          </v-text-field>
          <v-spacer></v-spacer>
          <v-dialog v-model="internshipDialog" max-width="700px" persistent :key="key">
            <template v-slot:activator="{ on }">
              <v-btn class="new-item-button" color="primary" depressed @click="showInternshipDialog"
                >New Internship</v-btn
              >
            </template>
            <v-card>
              <v-card-title>Internship</v-card-title>
              <v-card-text>
                <v-layout column>
                  <v-text-field
                    label="Internship Name*"
                    v-model="selectedInternship.name"
                    :rules="[rules.required]"
                    required
                  >
                  </v-text-field>
                  <v-textarea
                    label="Description*"
                    v-model="selectedInternship.description"
                    :rules="[rules.required]"
                    required
                  >
                  </v-textarea>
                  <v-text-field
                    label="Contact Name*"
                    v-model="selectedInternship.contactName"
                    :rules="[rules.required]"
                    required
                  >
                  </v-text-field>
                  <v-text-field
                    label="Contact Email*"
                    v-model="selectedInternship.contactEmail"
                    :rules="[rules.required, rules.email]"
                    required
                  ></v-text-field>
                  <v-text-field
                    label="Contact Phone"
                    v-model="selectedInternship.contactPhoneNumber"
                    :rules="[rules.phoneNumber]"
                  ></v-text-field>
                  <v-text-field
                    label="Location"
                    v-model="selectedInternship.location"
                  ></v-text-field>
                  <v-text-field
                    label="Company Website"
                    v-model="selectedInternship.website"
                  ></v-text-field>
                  <v-text-field
                    label="Number of Students"
                    v-model="selectedInternship.numStudents"
                    :rules="[rules.numValidation]"
                  ></v-text-field>
                  <v-textarea
                    label="Required Skills"
                    v-model="selectedInternship.requiredSkills"
                  ></v-textarea>
                  <v-textarea
                    label="Timeline"
                    v-model="selectedInternship.timeline"
                  ></v-textarea>
                </v-layout>
                <small>*indicates required field</small>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  text
                  v-if="!isEditInternship"
                  @click="saveNewInternship"
                  color="primary"
                  >Save</v-btn
                >
                <v-btn
                  text
                  v-if="isEditInternship"
                  @click="saveEditInternship"
                  color="primary"
                  >Save Changes</v-btn
                >
                <v-btn color="error" text @click="resetInternshipDialog"
                  >Cancel</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>
      <template v-slot:item.action="{ item }">
        <v-btn small text icon>
          <v-icon @click="setEditInternship(item)">edit</v-icon>
        </v-btn>
        <v-btn small text icon>
          <v-icon color="error" @click="showInternshipMessage(item)"
            >clear</v-icon
          >
        </v-btn>
      </template>
    </v-data-table>
    <v-dialog v-model="internshipMessage" max-width="500px" persistent>
      <v-card>
        <v-card-title
          >Are you sure you want to delete this internship?</v-card-title
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="deleteInternship">Yes</v-btn>
          <v-btn color="error" text @click="hideInternshipMessage()">No</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import {
  getUsers,
  postUser,
  putUser,
  deleteUser,
  getRoles,
  getInternships,
  postInternship,
  putInternship,
  deleteInternship,
} from "../services/services";

export default {
  name: "Users",
  data() {
    return {
      internshipHeaders: [
        { text: "Name", value: "name" },
        { text: "Contact Name", value: "contactName" },
        { text: "Contact Email", value: "contactEmail" },
        { text: "Number of Students", value: "numStudents" },
        {
          text: "Actions",
          value: "action",
          sortable: false,
          align: "center",
        },
      ],
      userHeaders: [
        { text: "First Name", value: "firstName" },
        { text: "Last Name", value: "lastName" },
        { text: "NetID", value: "netId" },
        { text: "Role", value: "roleName" },
        {
          text: "Actions",
          value: "action",
          sortable: false,
          align: "center",
        },
      ],
      roles: [
        { name: "Faculty", id: 0 },
        { name: "Admin", id: 1 },
      ],
      users: [],
      internships: [],
      internshipDialog: false,
      userDialog: false,
      key: 1,
      selectedUser: {},
      selectedInternship: {},
      isEdit: false,
      isEditInternship: false,
      userMessage: false,
      internshipMessage: false,
      dialogText: "",
      messageDialog: false,
      searchUsers: "",
      searchInternships: "",
      rules: {
        required: (value) => !!value || "This field is required.",
        counter: (value) => value.length <= 20 || "Max 20 characters",
        email: (value) => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Invalid e-mail. (ex. test@test.com)";
        },
        phoneNumber: (value) => {
          const pattern = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im;
          return (
            pattern.test(value) ||
            "Invalid phone number (ex. (123)456-7890, 111-111-1111, or 1234567890)"
          );
        },
        numValidation: (value) => {
          const pattern = /\d/;
          return pattern.test(value) || "Must be a number.";
        },
      },
    };
  },
  mounted() {
    getUsers().then((data) => {
      this.users = data;
    });
    getRoles().then((data) => {
      this.roles = data;
    });
    getInternships().then((data) => {
      this.internships = data;
    });
  },
  methods: {
    showUserMessage(data) {
      this.userMessage = true;
      this.selectedUser = data;
    },
    hideUserMessage(){
      this.userMessage = false;
      this.selectedUser = {};
    },
    showInternshipMessage(data) {
      this.internshipMessage = true;
      this.selectedInternship = data;
    },
    hideInternshipMessage(){
      this.internshipMessage = false;
      this.selectedInternship = {};
    },
    hideMessageDialog() {
      this.messageDialog = false;
    },

    // User
    saveNewUser() {
      if (
        this.selectedUser.firstName != "" &&
        this.selectedUser.firstName != null &&
        this.selectedUser.lastName != "" &&
        this.selectedUser.lastName != null &&
        this.selectedUser.roleId != null &&
        this.selectedUser.netId != "" &&
        this.selectedUser.netId != null
      ) {
        postUser(this.selectedUser).then((data) => {
          if (!data) {
            this.dialogText =
              "There was an error in adding the User to the database";
            this.messageDialog = true;
          } else {
            this.resetUserDialog();
            this.users.push(data);
          }
        });
      } else {
        this.dialogText = "Please fill out all of the fields";
        this.messageDialog = true;
      }
    },
    saveEditUser() {
      putUser(this.selectedUser).then((data) => {
        let userById = this.users.find((u) => u.id == data.id);
        const idx = this.users.indexOf(userById);
        this.users[idx] = this.selectedUser;

        const arr = [...this.users];
        arr[idx] = { ...data };
        this.users = arr;
        this.resetUserDialog();
      });
    },
    deleteUser() {
      deleteUser(this.selectedUser.id).then((data) => {
        this.userMessage = false;
        const idx = this.users.indexOf(this.selectedUser);
        this.users.splice(idx, 1);
        this.resetUserDialog();
      });
    },
    setEditUser(data) {
      this.key++;
      this.selectedUser = { ...data };
      this.userDialog = true;
      this.isEdit = true;
    },
    resetUserDialog() {
      this.selectedUser = {};
      this.isEdit = false;
      this.userDialog = false;
    },


    // Internship
    showInternshipDialog(){
      this.key++;
      this.internshipDialog = true;
    },
    setEditInternship(data) {
      this.key++;
      this.selectedInternship = { ...data };
      this.internshipDialog = true;
      this.isEditInternship = true;
    },
    saveNewInternship() {
      if (
        this.selectedInternship.name != "" &&
        this.selectedInternship.name != null &&
        this.selectedInternship.contactEmail != "" &&
        this.selectedInternship.contactEmail != null &&
        this.selectedInternship.contactName != null &&
        this.selectedInternship.contactName != "" &&
        this.selectedInternship.description != null &&
        this.selectedInternship.description != ""
      ) {
        postInternship(this.selectedInternship).then((data) => {
          if (!data) {
            this.dialogText =
              "There was an error in adding the Internship to the database";
            this.messageDialog = true;
          } else {
            this.resetInternshipDialog();
            this.internships.push(data);
          }
        });
      } else {
        this.dialogText = "Please fill out all of the fields";
        this.messageDialog = true;
      }
    },
    saveEditInternship() {
      putInternship(this.selectedInternship).then((data) => {
        let internshipById = this.internships.find((u) => u.id == data.id);
        const idx = this.internships.indexOf(internshipById);

        const arr = [...this.internships];
        arr[idx] = { ...data };
        this.internships = arr;

        this.resetInternshipDialog();
      });
    },
    deleteInternship() {
      deleteInternship(this.selectedInternship.id).then((data) => {
        this.internshipMessage = false;
        const idx = this.internships.indexOf(this.selectedInternship);
        this.internships.splice(idx, 1);
        this.resetInternshipDialog();
      });
    },
    resetInternshipDialog() {
      this.selectedInternship = {};
      this.isEditInternship = false;
      this.internshipDialog = false;
    },
  },
};
</script>

<style scoped>
#user-header {
  text-align: left;
  font: normal normal bold 40px/47px "HCo Ringside Narrow SSm";
  letter-spacing: 0px;
  color: #002e5d;
  opacity: 1;
  margin-bottom: 30px;
}

#search-container {
  width: 350px;
  margin-right: 100px;
}

@media screen and (max-width: 600px) {
  #search-container {
    width: 60%;
    margin-right: 40px;
  }
}
</style>
